import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import MessageIcon from '@material-ui/icons/Message';
import MessageOutlinedIcon from '@material-ui/icons/MessageOutlined';
import { MESSAGE_READ_STATUS } from 'features/message-center/constants';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';
import { FPButtonMenu } from 'UI/components/molecules';

import { StyledIcon } from '../Chat';

import { Container } from './SelectConversations.styled';

export const SelectConversations = ({ onClose, count = 0, onClickMarkConversations }) => {
  const menuItems = [
    {
      title: strings.formatString(strings.messageCenter.markAs, {
        status: MESSAGE_READ_STATUS.read
      }),
      icon: (
        <StyledIcon>
          <MessageOutlinedIcon fontSize="small" />
        </StyledIcon>
      ),
      action: () => onClickMarkConversations(MESSAGE_READ_STATUS.read),
      visible: true
    },
    {
      title: strings.formatString(strings.messageCenter.markAs, {
        status: MESSAGE_READ_STATUS.unread
      }),
      icon: (
        <StyledIcon>
          <MessageIcon fontSize="small" />
        </StyledIcon>
      ),
      action: () => onClickMarkConversations(MESSAGE_READ_STATUS.unread),
      visible: true
    }
  ];

  return (
    <Container>
      <Box display="flex" alignItems="center" gap={2}>
        <FPIconButton
          onClick={onClose}
          tooltipProps={{
            title: strings.shared.ui.cancel
          }}
        >
          <CloseIcon color="primary" />
        </FPIconButton>

        <Typography variant="subtitle1">{count} selected</Typography>
      </Box>
      {count > 0 && (
        <FPButtonMenu isIconButton menuItems={menuItems} title={strings.shared.rowActions.more} />
      )}
    </Container>
  );
};
